export const TRACKER_LOGIN_WITH_SAML_SSO_CLICK = '[SAML SSO Login] login with SAML click';
